import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useEditAreaNode from 'api/locationsCategories/useEditAreaNode';
import React, { useState } from 'react';

const EditAreaNodeModal = props => {
  const { guid, defaultName } = props;

  const [editLoading, editAreaNode] = useEditAreaNode();

  const [itemName, setItemName] = useState(defaultName);

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.closeHandler();
        setItemName('');
      }}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>آپدیت ناحیه</DialogTitle>

      <DialogContent>
        <FormControl sx={{ m: 1, minWidth: 300 }}>
          <TextField
            autoFocus
            label="عنوان ناحیه"
            variant="standard"
            value={itemName}
            onChange={e => setItemName(e.target.value)}
          />
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={editLoading}
          disabled={!itemName}
          onClick={() => editAreaNode(guid, itemName, props.refreshData)}
        >
          تایید
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={editLoading}
          onClick={() => {
            props.closeHandler();
            setItemName('');
          }}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditAreaNodeModal;
